import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import Shop from "../src/Pages/Shop";
import Contact from "../src/Pages/Contact";
import Blog from "../src/Pages/Blog";
import Careers from "../src/Pages/Careers";
import MedicalServices from "../src/Pages/MedicalServices";
import MedicalAccessories from "../src/Pages/MedicalAccessories";
import MensHealth from "../src/Pages/MensHealth";
import WomensHealth from "../src/Pages/WomensHealth";
import CustomerService from "../src/Pages/CustomerService";
import LegalPrivacy from "../src/Pages/LegalPrivacy";
import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import ProductDetails from "./Pages/ProductDetails";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./ScrollToTop.jsx"
import Authentication from "./Pages/Authentication";
import ResetPass from "./Components/Authentication/Reset/ResetPass";
import BlogDetails from "./Components/Blog/BlogDetails/BlogDetails";
import TermsConditions from "./Pages/TermsConditions";
import ShoppingCart from "./Components/ShoppingCart/ShoppingCart";
import { Toaster } from "react-hot-toast";
import Medecines from "./Components/Home/Medicine/Medecines";
import Allmedicine from "./Components/AllMedicine/AllMedicine";
import { Provider, useDispatch, useSelector } from "react-redux";

// Import the PrivateRoute component
import PrivateRoute from "./Components/PrivateRoute";

import store from "./App/store.js";
import { fetchCartAsync, syncWithLocalStorage, hydrateCart } from "./Features/Cart/cartSlice";
import Layout from "./Layout/Layout.jsx";
import SearchResults from './Components/SearchResults/SearchResults';
import UserDashboard from "./Pages/Dashboard/userDashboard.jsx";
import Invoice from "./Pages/Dashboard/Invoice.jsx";
import AddPrescriptionForm from "./Components/Prescription/AddPrescriptionForm.jsx";
import PrescriptionPage from "./Components/Prescription/PrescriptionPage.jsx";
import { fetchStore } from "./Features/User/UserSlice.js";
import ShopByCategory from "./Components/ShopByCategory/ShopByCategory";
import ShopByBrand from "./Components/ShopByBrand/ShopByBrand";
import RegisterUserMedical from "./Components/RegisterUserMedical/RegisterUserMedical.js";
import LoginForm from "./Components/LoginForm/LoginForm.jsx";
import FindNearestUser from "./Components/FindNearestUser/FindNearestUser.js";
import CategoryMedicines from "./Components/CategoryMedicines/CategoryMedicines";
import FormPage from "./Components/CallForAppointment/FormPage.jsx";
import Nav from "./Components/Navbar/Nav.jsx";
import LoginSignUp from "./Components/Authentication/LoginSign/LoginSignUp.jsx";
import DoctorAppointment from "./Components/DoctorAppointment/DoctorAppointment.jsx";
import DoctorList from "./Components/DoctorAppointment/DoctorList.jsx";
import HospitalDetail from "./Components/DoctorAppointment/HospitalDetail.jsx";
import LabTestForm from "./Components/LabTestForm/LabTestForm.jsx";
import PopularCategory from "./Components/PopularCategeory/PopularCategeory.jsx";
import AllMeds from "./Components/AllMedicines/AllMeds.jsx";

const App = () => {
  const userId = useSelector((state) => state.user.user?._id);
  const Kashi = useSelector((state) => state.user.user?.storeId);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  // Fetch cart data when user ID is available
  useEffect(() => {
    if (userId) {
      dispatch(fetchCartAsync(userId));
      dispatch(fetchStore(Kashi));
    }
  }, [userId, dispatch]);

  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Header />
          <div className="hide-on-laptop">
            <Nav />
          </div>
          <ScrollToTop/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginSignUp />} />
            <Route path="/register" element={<RegisterUserMedical />} />
            <Route path="/near" element={<FindNearestUser />} />
            <Route path="/labtest" element={<LabTestForm/>} />
            <Route path="/appointment" element={<FormPage />} />
            <Route path="/AllMedicine" element={<AllMeds/>} />
            <Route path="/prescription" element={<Layout><PrescriptionPage /></Layout>} />
            <Route path="/doctorappoint" element={<Layout><DoctorAppointment/></Layout>} />
            {/* Protected Routes */}
            <Route path="/home" element={<PrivateRoute element={<Home />} />} />

            {/* Other routes */}
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/careers" element={<Layout><Careers /></Layout>} />
            <Route path="/customer-service" element={<Layout><CustomerService /></Layout>} />
            <Route path="/legal-privacy" element={<Layout><LegalPrivacy /></Layout>} />
            <Route path="/services/new-arrivals" element={<Layout><MedicalServices /></Layout>} />
            <Route path="/services/accessories" element={<Layout><MedicalAccessories /></Layout>} />
            <Route path="/services/men" element={<Layout><MensHealth /></Layout>} />
            <Route path="/services/women" element={<Layout><WomensHealth /></Layout>} />
            <Route path="/category/:category" element={<DoctorList/>} />
            <Route path="/hospital/:id" element={<HospitalDetail/>} />
            <Route path="/shop" element={<Layout><Allmedicine /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/blog" element={<Layout><Blog /></Layout>} />
            <Route path="/product/:id" element={<Layout><ProductDetails /></Layout>} />
            <Route path="/resetPassword" element={<Layout><ResetPass /></Layout>} />
            <Route path="/resetPassword/:token" element={<Layout><ResetPass /></Layout>} />
            <Route path="/BlogDetails" element={<Layout><BlogDetails /></Layout>} />
            <Route path="/terms" element={<Layout><TermsConditions /></Layout>} />
            <Route path="/cart" element={<Layout><ShoppingCart /></Layout>} />
            <Route path="/search" element={<Layout><SearchResults /></Layout>} />
            <Route path="/user-dashboard" element={<Layout><UserDashboard /></Layout>} />
            <Route path="/invoice" element={<Layout><Invoice /></Layout>} />
            <Route path="/shop-by-category" element={<Layout><ShopByCategory /></Layout>} />
            <Route path="/shop-by-brand" element={<Layout><ShopByBrand /></Layout>} />
            <Route path="/medcategory/:category" element={<Layout><CategoryMedicines /></Layout>} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
          <Footer/>
          <Toaster />
        </BrowserRouter>
      </Provider>
    </>
  );
};

export default App;